module.exports = __webpack_public_path__ + "img/dress.2cf7e6f8.png";